import React, { useState, useEffect, useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import DataComponentFinanceBlock from "../../../DataComponent/DataComponentFinanceBlock";
import { I18nContext } from 'utils/I18n/context';

const OperationHistoryPageContainer = ({
    accountEntries: propAccountEntries,
    headerNames: propHeaderNames,
    totalPages: propTotalPages,
    loading: propLoading,
    selectOptions,
    getAccountEntries
}) => {
    const { t } = useContext(I18nContext);
    const staticNames = t?.dataTable || {};

    const [accountEntries, setAccountEntries] = useState(propAccountEntries);
    const [headerNames, setHeaderNames] = useState(propHeaderNames);
    const [totalPages, setTotalPages] = useState(propTotalPages);
    const [loading, setLoading] = useState(propLoading);
    const [hasError, setHasError] = useState(false);

    // Sync with props changes
    useEffect(() => {
        setAccountEntries(propAccountEntries);
        setTotalPages(propTotalPages);
        setLoading(propLoading);
    }, [propAccountEntries, propTotalPages, propLoading]);

    const onDataTableAction = useCallback((state, actionType) => {
        if (getAccountEntries) {
            setHasError(false); // Reset error state when making new request
            getAccountEntries(state);
        }
    }, [getAccountEntries]);

    // Check for error state (empty data after loading)
    useEffect(() => {
        if (!loading && (!accountEntries || accountEntries.length === 0)) {
            setHasError(true);
        } else if (accountEntries && accountEntries.length > 0) {
            setHasError(false);
        }
    }, [loading, accountEntries]);

    // Show "Nothing found" message when there's an error
    if (hasError && !loading) {
        return (
            <div className="ibox">
                <div className="ibox-content text-center" style={{ padding: '40px 20px' }}>
                    <h4>{staticNames.nothingFound || 'Nothing found'}</h4>
                    <p>{staticNames.nothingFoundDescription || 'No data available at the moment.'}</p>
                </div>
            </div>
        );
    }

    return (
        <DataComponentFinanceBlock
            onAction={onDataTableAction}
            totalPages={totalPages}
            headerNames={headerNames}
            data={accountEntries}
            loading={loading}
            isQuery={true}
            className="simple-table payout-table"
            gray={true}
            fields={[
                {
                    name: 'datepicker',
                    key: 'create',
                    label: staticNames.headers?.createdAt || 'Created At',
                    dropdownLabel: staticNames.filter || 'Filter',
                    disabled: true
                },
                {
                    name: 'multiselect',
                    key: 'sources',
                    data: Array.isArray(selectOptions) ? selectOptions : [],
                    label: staticNames.headers?.reason || 'Reason',
                    dropdownLabel: staticNames.filter || 'Filter',
                    placeholder: staticNames.tips?.byReason || 'By reason',
                    hidden: true
                }
            ]}
        />
    );
};

OperationHistoryPageContainer.propTypes = {
    accountEntries: PropTypes.array,
    headerNames: PropTypes.array,
    totalPages: PropTypes.number,
    loading: PropTypes.bool,
    selectOptions: PropTypes.array,
    getAccountEntries: PropTypes.func
};

OperationHistoryPageContainer.defaultProps = {
    accountEntries: [],
    headerNames: [],
    totalPages: 0,
    loading: false,
    selectOptions: [],
    getAccountEntries: () => {}
};

export { OperationHistoryPageContainer };
